import React, { useState, useEffect } from 'react';
import './ReportScreen.css';

const ReportScreen = () => {
  // Get current month range
  const getMonthRange = () => {
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    return {
      from: firstDay.toISOString().split('T')[0],
      to: lastDay.toISOString().split('T')[0],
    };
  };

  const [clientName, setClientName] = useState('ALL CLIENTS');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');

  const [reportData, setReportData] = useState([
    { date: '2025-07-03', customer: 'ABC Ltd.', description: 'Invoice July', billNo: 'INV123', billAmt: 1000, recvAmt: 900, tds: 100 },
    { date: '2025-07-08', customer: 'XYZ Co.', description: 'Invoice July 2', billNo: 'INV124', billAmt: 2000, recvAmt: 1800, tds: 200 },
  ]);

  useEffect(() => {
    const { from, to } = getMonthRange();
    setFromDate(from);
    setToDate(to);
  }, []);

  const handleExport = () => {
    alert('Exporting to Excel...');
  };

  return (
    <div className="report-container">
      <div className="report-header">
        <div className="header-field big-client-select">
          <label className="label-bold">Client Name</label>
          <select value={clientName} onChange={e => setClientName(e.target.value)}>
            <option value="ALL CLIENTS">ALL CLIENTS</option>
            <option value="ABC Ltd.">ABC Ltd.</option>
            <option value="XYZ Co.">XYZ Co.</option>
          </select>
        </div>
        <div className="header-field">
          <label>From Date</label>
          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
        </div>
        <div className="header-field">
          <label>To Date</label>
          <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
        </div>
      </div>

      <div className="report-table-wrapper">
        <table className="report-table">
          <thead>
            <tr>
              <th>S. NO</th>
              <th>DATE</th>
              <th>CUSTOMER NAME</th>
              <th>DESCRIPTION</th>
              <th>BILL NO./REF. NO.</th>
              <th>BILL AMOUNT</th>
              <th>RECV AMOUNT</th>
              <th>TDS</th>
            </tr>
          </thead>
          <tbody>
            {reportData.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{row.date}</td>
                <td>{row.customer}</td>
                <td>{row.description}</td>
                <td>{row.billNo}</td>
                <td>{row.billAmt}</td>
                <td>{row.recvAmt}</td>
                <td>{row.tds}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="export-button-wrapper">
        <button onClick={handleExport}>To Export</button>
      </div>
    </div>
  );
};

export default ReportScreen;
